import PropTypes from "prop-types";
// material
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  return (
    <Box sx={{ width: 200, height: 50, ...sx }} >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 439.466 85.441"
      >
        <g
          id="Original_Logo"
          data-name="Original Logo"
          transform="translate(-580.336 283.989)"
        >
          <g
            id="Group_21"
            data-name="Group 21"
            transform="translate(580.336 -283.989)"
          >
            <g id="Group_5" data-name="Group 5" transform="translate(0 0)">
              <g
                id="Group_2"
                data-name="Group 2"
                transform="translate(0 1.223)"
              >
                <g id="Group_1" data-name="Group 1">
                  <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M109.289,124.356c.182-18.8-26.963-20.758-32.255-33.715s12.546-21.4,12.546-21.4C72.928,73.943,60.564,86.58,64.4,99.72c3.463,11.875,18.112,14.188,26.461,21.443,11.189,9.722-1.484,24.89-6.159,32.3C94.494,147.387,109.2,134,109.289,124.356Z"
                    transform="translate(-63.695 -69.244)"
                    fill="#21d8aa"
                  />
                </g>
              </g>
              <g
                id="Group_4"
                data-name="Group 4"
                transform="translate(2.038 0)"
              >
                <g id="Group_3" data-name="Group 3" transform="translate(0)">
                  <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M115.1,120.867c.183-18.8-26.963-20.758-32.255-33.715S95.4,65.755,95.4,65.755c-16.652,4.7-29.016,17.337-25.183,30.476,3.463,11.874,18.112,14.188,26.461,21.443,11.189,9.722-1.484,24.89-6.159,32.3C100.31,143.9,115.011,130.507,115.1,120.867Z"
                    transform="translate(-69.511 -65.755)"
                    fill="#2064d8"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_6"
              data-name="Group 6"
              transform="translate(53.222 21.15)"
            >
              <path
                id="Path_3"
                data-name="Path 3"
                d="M220.3,162.138a14.2,14.2,0,0,0,8.759,3.722c3.339,0,4.981-1.314,4.981-3.448,0-2.245-2.025-2.956-5.145-4.27l-4.6-1.971c-3.722-1.478-7.226-4.543-7.226-9.744,0-5.912,5.31-10.62,12.7-10.62a16.525,16.525,0,0,1,11.5,4.708l-4.051,5.091a11.71,11.71,0,0,0-7.445-2.846c-2.737,0-4.543,1.2-4.543,3.229,0,2.19,2.354,2.956,5.474,4.215l4.543,1.861c4.324,1.752,7.061,4.653,7.061,9.689,0,5.912-4.927,11.058-13.411,11.058a19.775,19.775,0,0,1-13.247-5.146Z"
                transform="translate(-215.647 -132.467)"
                fill="#2064d8"
              />
              <path
                id="Path_4"
                data-name="Path 4"
                d="M294.561,131.98c0-2.464,1.971-4.16,4.653-4.16,2.737,0,4.653,1.7,4.653,4.16s-1.916,4.215-4.653,4.215C296.532,136.2,294.561,134.443,294.561,131.98Z"
                transform="translate(-263.195 -127.654)"
                fill="#21d8aa"
              />
              <rect
                id="Rectangle_1"
                data-name="Rectangle 1"
                width="8.047"
                height="27.151"
                transform="translate(32.023 12.537)"
                fill="#2064d8"
              />
              <path
                id="Path_5"
                data-name="Path 5"
                d="M334.224,157.949h6.569l.547,3.5h.219c2.244-2.245,4.653-4.161,8.211-4.161,3.832,0,6.131,1.642,7.5,4.544,2.409-2.464,4.927-4.544,8.54-4.544,5.857,0,8.484,4.161,8.484,10.948V185.1h-8.047V169.28c0-3.941-1.04-5.145-3.339-5.145-1.369,0-2.9.876-4.653,2.627V185.1h-8.047V169.28c0-3.941-1.04-5.145-3.339-5.145-1.314,0-2.9.876-4.6,2.627V185.1h-8.047Z"
                transform="translate(-287.093 -145.412)"
                fill="#2064d8"
              />
              <path
                id="Path_6"
                data-name="Path 6"
                d="M460.3,187.235v7.937h-8.047V157.949h6.569l.547,2.682h.219a11.932,11.932,0,0,1,7.718-3.339c6.568,0,10.62,5.42,10.62,13.795,0,9.306-5.584,14.67-11.441,14.67a9.409,9.409,0,0,1-6.459-2.846Zm4.324-8.047c2.792,0,5.036-2.408,5.036-7.992,0-4.872-1.478-7.335-4.708-7.335-1.642,0-3.065.766-4.653,2.463v11.112A6.241,6.241,0,0,0,464.625,179.188Z"
                transform="translate(-358.21 -145.412)"
                fill="#2064d8"
              />
              <path
                id="Path_7"
                data-name="Path 7"
                d="M531.171,130.712h8.047v30.272c0,1.7.766,2.244,1.423,2.244a3.372,3.372,0,0,0,.985-.11l.985,5.967a10.5,10.5,0,0,1-4.051.657c-5.529,0-7.39-3.613-7.39-9.086Z"
                transform="translate(-405.76 -129.397)"
                fill="#2064d8"
              />
              <path
                id="Path_8"
                data-name="Path 8"
                d="M579.375,157.292c7.718,0,11.55,5.638,11.55,13.029a15.939,15.939,0,0,1-.329,3.394H574.339c.712,4.105,3.449,5.912,7.062,5.912a10.931,10.931,0,0,0,5.857-1.807l2.683,4.872a17.762,17.762,0,0,1-9.634,3.066c-7.773,0-13.74-5.255-13.74-14.233C566.566,162.712,572.861,157.292,579.375,157.292Zm4.707,11.441c0-3.121-1.314-5.31-4.543-5.31-2.518,0-4.707,1.7-5.255,5.31Z"
                transform="translate(-427.087 -145.412)"
                fill="#2064d8"
              />
              <path
                id="Path_9"
                data-name="Path 9"
                d="M221.017,161.527a14.117,14.117,0,0,0,8.709,3.7c3.32,0,4.953-1.306,4.953-3.429,0-2.232-2.014-2.939-5.117-4.246l-4.572-1.96c-3.7-1.469-7.185-4.518-7.185-9.689,0-5.879,5.279-10.56,12.628-10.56a16.429,16.429,0,0,1,11.43,4.681l-4.028,5.062a11.645,11.645,0,0,0-7.4-2.83c-2.721,0-4.518,1.2-4.518,3.211,0,2.178,2.341,2.94,5.443,4.191l4.518,1.851c4.3,1.742,7.022,4.627,7.022,9.635,0,5.879-4.9,10.995-13.336,10.995a19.667,19.667,0,0,1-13.173-5.116Z"
                transform="translate(-216.095 -132.188)"
                fill="#2064d8"
              />
              <path
                id="Path_10"
                data-name="Path 10"
                d="M294.858,131.54c0-2.449,1.96-4.137,4.627-4.137,2.721,0,4.626,1.688,4.626,4.137s-1.905,4.191-4.626,4.191C296.818,135.731,294.858,133.989,294.858,131.54Z"
                transform="translate(-263.374 -127.403)"
                fill="#21d8aa"
              />
              <rect
                id="Rectangle_2"
                data-name="Rectangle 2"
                width="8.001"
                height="26.998"
                transform="translate(32.137 12.302)"
                fill="#2064d8"
              />
              <path
                id="Path_11"
                data-name="Path 11"
                d="M334.3,157.362h6.532l.545,3.483h.218c2.232-2.232,4.627-4.137,8.165-4.137,3.811,0,6.1,1.633,7.457,4.518,2.4-2.449,4.9-4.518,8.491-4.518,5.824,0,8.437,4.137,8.437,10.886V184.36h-8V168.629c0-3.919-1.034-5.117-3.321-5.117-1.36,0-2.885.871-4.627,2.613V184.36h-8V168.629c0-3.919-1.034-5.117-3.32-5.117-1.307,0-2.885.871-4.572,2.613V184.36h-8Z"
                transform="translate(-287.137 -145.061)"
                fill="#2064d8"
              />
              <path
                id="Path_12"
                data-name="Path 12"
                d="M459.659,186.483v7.893h-8V157.362h6.532l.544,2.667h.218a11.865,11.865,0,0,1,7.675-3.32c6.532,0,10.56,5.389,10.56,13.717,0,9.253-5.553,14.587-11.376,14.587a9.36,9.36,0,0,1-6.424-2.83Zm4.3-8c2.775,0,5.007-2.4,5.007-7.947,0-4.845-1.469-7.294-4.681-7.294-1.633,0-3.048.762-4.627,2.449v11.05A6.211,6.211,0,0,0,463.96,178.482Z"
                transform="translate(-357.851 -145.061)"
                fill="#2064d8"
              />
              <path
                id="Path_13"
                data-name="Path 13"
                d="M530.127,130.279h8v30.1c0,1.687.762,2.232,1.415,2.232a3.342,3.342,0,0,0,.98-.109l.979,5.933a10.422,10.422,0,0,1-4.027.653c-5.5,0-7.348-3.592-7.348-9.035Z"
                transform="translate(-405.131 -129.136)"
                fill="#2064d8"
              />
              <path
                id="Path_14"
                data-name="Path 14"
                d="M578.059,156.709c7.675,0,11.486,5.606,11.486,12.955a15.855,15.855,0,0,1-.327,3.375H573.052c.708,4.082,3.429,5.879,7.021,5.879a10.873,10.873,0,0,0,5.825-1.8l2.667,4.845a17.66,17.66,0,0,1-9.58,3.048c-7.73,0-13.663-5.225-13.663-14.152C565.322,162.1,571.582,156.709,578.059,156.709Zm4.682,11.376c0-3.1-1.307-5.28-4.518-5.28-2.5,0-4.681,1.688-5.225,5.28Z"
                transform="translate(-426.337 -145.061)"
                fill="#2064d8"
              />
            </g>
            <g
              id="Group_7"
              data-name="Group 7"
              transform="translate(224.518 26.369)"
            >
              <path
                id="Path_15"
                data-name="Path 15"
                d="M667.843,167.587H656.957l-2.178,8.437h-8.165l11.159-35.489h9.58l11.158,35.489H670.02Zm-1.633-6.26-.871-3.266c-.98-3.538-1.9-7.729-2.885-11.43h-.217c-.817,3.756-1.8,7.893-2.776,11.43l-.871,3.266Z"
                transform="translate(-646.614 -140.535)"
                fill="#21d8aa"
              />
              <path
                id="Path_16"
                data-name="Path 16"
                d="M744.742,160.254a10.9,10.9,0,0,1,7.893,3.1l-3.647,4.954a5.774,5.774,0,0,0-3.756-1.579c-3.865,0-6.314,2.994-6.314,7.675s2.558,7.675,6.042,7.675a7.784,7.784,0,0,0,4.844-1.96l3.211,5.062a14.008,14.008,0,0,1-8.981,3.375c-7.512,0-13.336-5.171-13.336-14.152S737.285,160.254,744.742,160.254Z"
                transform="translate(-697.278 -152.416)"
                fill="#21d8aa"
              />
              <path
                id="Path_17"
                data-name="Path 17"
                d="M804.862,160.254a10.9,10.9,0,0,1,7.892,3.1l-3.647,4.954a5.774,5.774,0,0,0-3.756-1.579c-3.865,0-6.314,2.994-6.314,7.675s2.559,7.675,6.042,7.675a7.785,7.785,0,0,0,4.845-1.96l3.212,5.062a14.011,14.011,0,0,1-8.981,3.375c-7.512,0-13.336-5.171-13.336-14.152S797.4,160.254,804.862,160.254Z"
                transform="translate(-733.501 -152.416)"
                fill="#21d8aa"
              />
              <path
                id="Path_18"
                data-name="Path 18"
                d="M864.109,160.254c6.8,0,13.118,5.171,13.118,14.152s-6.314,14.152-13.118,14.152c-6.858,0-13.173-5.171-13.173-14.152S857.25,160.254,864.109,160.254Zm0,21.827c3.265,0,4.953-2.994,4.953-7.675s-1.688-7.675-4.953-7.675c-3.321,0-4.954,2.994-4.954,7.675S860.788,182.081,864.109,182.081Z"
                transform="translate(-769.724 -152.416)"
                fill="#21d8aa"
              />
              <path
                id="Path_19"
                data-name="Path 19"
                d="M930.228,161.9h8v15.731c0,3.865,1.034,5.116,3.375,5.116,2.014,0,3.212-.87,4.79-2.993V161.9h8v27h-6.531l-.6-3.756H947.1c-2.286,2.721-4.79,4.409-8.491,4.409-5.878,0-8.382-4.136-8.382-10.886Z"
                transform="translate(-817.5 -153.407)"
                fill="#21d8aa"
              />
              <path
                id="Path_20"
                data-name="Path 20"
                d="M1008.7,160.907h6.532l.545,3.429h.218c2.286-2.177,5.007-4.082,8.654-4.082,5.879,0,8.382,4.137,8.382,10.886v16.765h-8V172.174c0-3.919-1.034-5.117-3.32-5.117-2.014,0-3.266.925-5.008,2.613v18.234h-8Z"
                transform="translate(-864.779 -152.416)"
                fill="#21d8aa"
              />
              <path
                id="Path_21"
                data-name="Path 21"
                d="M1084.156,157.265h-3.7v-5.933l4.137-.326.926-7.185h6.64v7.185h6.477v6.259h-6.477V168.1c0,3.048,1.361,4.3,3.484,4.3a7.643,7.643,0,0,0,2.558-.545l1.252,5.824a19.444,19.444,0,0,1-5.988.979c-6.7,0-9.308-4.191-9.308-10.451Z"
                transform="translate(-908.016 -142.515)"
                fill="#21d8aa"
              />
              <path
                id="Path_22"
                data-name="Path 22"
                d="M1137.044,179.795c2.449,1.851,4.681,2.831,6.967,2.831,2.4,0,3.429-.871,3.429-2.286,0-1.8-2.721-2.613-5.5-3.7-3.266-1.252-7.131-3.483-7.131-7.947,0-5.008,4.083-8.437,10.342-8.437a15.526,15.526,0,0,1,9.525,3.429l-3.592,4.79a9.955,9.955,0,0,0-5.715-2.286c-2.069,0-3.048.762-3.048,2.123,0,1.741,2.5,2.394,5.28,3.429,3.429,1.252,7.294,3.157,7.294,8.111,0,4.9-3.865,8.709-11.1,8.709a17.429,17.429,0,0,1-10.342-3.755Z"
                transform="translate(-939.949 -152.416)"
                fill="#21d8aa"
              />
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
}
